import { ComponentsOverrides } from '@mui/material/styles';

import { INPUT_WIDTH } from '../theme/constants';

function getSize(size: string) {
  switch (size) {
    case 'xs':
      return INPUT_WIDTH.XS;
    case 'date':
      return INPUT_WIDTH.DATE;
    case 'small':
      return INPUT_WIDTH.SMALL;
    case 'medium':
      return INPUT_WIDTH.MEDIUM;
    case 'large':
      return INPUT_WIDTH.LARGE;
    default:
      return INPUT_WIDTH.MEDIUM;
  }
}

const styleOverrides: ComponentsOverrides['MuiInputBase'] = {
  root: ({ ownerState }) => ({
    width: ownerState.fullWidth ? INPUT_WIDTH.FULL : getSize(ownerState.size ?? 'medium'),
    maxWidth: '100%',
  }),
  adornedStart: {
    paddingLeft: 12,
  },
  adornedEnd: {
    paddingRight: 12,
  },
  inputAdornedStart: {
    paddingRight: 8,
  },
  inputAdornedEnd: {
    paddingLeft: 8,
  },
};

export default styleOverrides;
